<script>
import Plan from "./Plan.vue";
import AppointmentForm from "../../../modules/Planners/molecules/AppointmentForm.vue";

export default {
    name: "PlanMenu",
    extends: Plan,
    components: {Plan},
    data() {
        return {
            type: 'appointment',
            component: AppointmentForm
        }
    },
}
</script>
